var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","lg":"6"}},[_vm._t("Main"),_vm._t("BottomLeft")],2),_c('v-col',{attrs:{"cols":"12","lg":"6"}},[_vm._t("TopRight"),_vm._t("BottomRight")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }